import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';
import React, { useEffect, useState } from 'react';
import { differenceInHours, differenceInMinutes, isAfter } from 'date-fns';
import { useCardsRouterContext } from '@apps/card/Card.routes';

interface EditCardCountdownProps {
  editingEndsAt: string;
  orderNumber: string;
}

const EditCardCountdown: React.FC<EditCardCountdownProps> = ({ editingEndsAt, orderNumber }) => {
  const [duration, setDuration] = useState('');
  const { goToCustomizeOrderDetails } = useCardsRouterContext();

  useEffect(() => {
    const calculate = () => {
      const now = new Date();
      const hours = differenceInHours(new Date(editingEndsAt), now);
      const minutes = differenceInMinutes(new Date(editingEndsAt), now) % 60;

      setDuration(`${hours} hours ${minutes} minutes`);
    };

    calculate();
    const interval = setInterval(calculate, 60 * 1000);

    return () => clearInterval(interval);
  }, [editingEndsAt, setDuration]);

  const openEditCard = () => {
    goToCustomizeOrderDetails(orderNumber);
  };

  if (isAfter(new Date(), new Date(editingEndsAt))) {
    return null;
  }

  return (
    <Flex padding={6} border="1px solid #FFD8BB" borderRadius={3} gap={6}>
      <Info flex="none" color="#E0946D" size={32} />
      <Flex flexDirection="column" gap={3}>
        <TextV2 color="mono12">
          Noticed a mistake on your card? Don’t worry, that happens! Let’s get it right. You have{' '}
          <Box display="inline" fontWeight="bold" _hover={{ cursor: 'pointer' }} onClick={openEditCard}>
            {duration}
          </Box>{' '}
          left to make the changes needed.
        </TextV2>
        <Box
          alignSelf="flex-start"
          cursor="pointer"
          typographyVariant="body2"
          fontWeight={600}
          borderBottom="1px solid #EBEBEB"
          borderRadius={0}
          lineHeight={1}
          paddingY={1}
          onClick={openEditCard}
          __css={{ _hover: { borderBottomColor: 'transparent' } }}
        >
          Edit Your Card
        </Box>
      </Flex>
    </Flex>
  );
};

export default EditCardCountdown;
